import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function WhoIsThisFor() {
  const isForYou = ['Eres dueña de un spa, clínica estética o salón de belleza', 'Ofreces tratamientos premium (Botox, laser, microblading, faciales avanzados)', 'Estás cansada de competir por precio y quieres clientes que valoren tu trabajo', 'Quieres un flujo constante de clientes nuevos sin depender de referidos', 'Estás lista para invertir en el crecimiento real de tu negocio'];
  const notForYou = ['Buscas resultados sin invertir en publicidad', 'No estás dispuesta a cobrar lo que realmente valen tus servicios', 'Prefieres seguir dependiendo de cupones y descuentos', 'No tienes un negocio establecido (esto es para spas que ya operan)'];
  return <section className="py-20 md:py-28 px-4 bg-carbon relative border-t border-border" data-id="element-239">
      <div className="max-w-6xl mx-auto" data-id="element-240">
        <motion.div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-241">
          {/* Is For You Column */}
          <motion.div variants={itemVariants} className="bg-surface border border-border rounded-2xl p-8 md:p-10 shadow-xl" data-id="element-242">
            <h3 className="text-2xl md:text-3xl font-bold text-gold mb-8" data-id="element-243">
              Esto Es Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-244">
              {isForYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-245">
                  <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mt-0.5" aria-hidden="true" data-id="element-246" />
                  <span className="text-neutral-300 text-base md:text-lg leading-relaxed" data-id="element-247">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You Column */}
          <motion.div variants={itemVariants} className="bg-surface border border-border rounded-2xl p-8 md:p-10 shadow-xl opacity-90" data-id="element-248">
            <h3 className="text-2xl md:text-3xl font-bold text-neutral-400 mb-8" data-id="element-249">
              No Es Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-250">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-251">
                  <XCircle className="w-6 h-6 text-red-500/80 shrink-0 mt-0.5" aria-hidden="true" data-id="element-252" />
                  <span className="text-neutral-400 text-base md:text-lg leading-relaxed" data-id="element-253">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}